import './Title.css'
const Title = () => {
    return (
        <div className='title-wrapper'>
           <h1 className='first-title'>Say hello</h1> 
           <h3 className='second-title'>Connect with me</h3> 
        </div>
    )
}

export default Title
